// src/store/ui/uiSelectors.ts
import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

/**
 * Selects the entire UI state from the Redux store.
 * @param state - The root Redux state.
 * @returns The UI slice of state.
 */
export const selectUiState = (state: RootState) => state.ui;

/**
 * Selects the current open modal from the UI state.
 * @returns The current modal value or null if none open.
 */
export const selectModal = createSelector(
  selectUiState,
  (ui) => ui.modal
);

/**
 * Determines if the create six modal is open.
 * @returns True if the "createSix" modal is open, otherwise false.
 */
export const selectIsCreateSixModal = createSelector(
  selectUiState,
  (ui) => ui.modal === "createSix"
);

export const selectShowLoader = createSelector(
  selectUiState,
  (ui) => ui.loaderCount > 0,
);

export const selectIsManageAccessModal = createSelector(
  selectUiState,
  (ui) => ui.modal === 'manageAccess'
);

export const selectIsFileUploadModal = createSelector(
  selectUiState,
  (ui) => ui.modal === 'fileUpload'
);

export const selectIsFileDetailModal = createSelector(
  selectUiState,
  (ui) => ui.modal === 'fileDetail'
);

export const selectIsCreateFolderModal = createSelector(
  selectUiState,
  (ui) => ui.modal === 'createFolder'
);
